import * as React from 'react'
import { ExternalLink } from '../../components/public_site/utils/external_link'
import { StyleguideImgPlaceholder } from '../helpers.mod'

export const breadcrumbs = () => (
  <nav className="breadcrumb text--s">
    <div className="breadcrumb__inner container container--m grid--gutter">
      <ul className="breadcrumb__list">
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Home
            </span>
          </a>
        </li>
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Products
            </span>
          </a>
        </li>
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Doors and portals
            </span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
)

export const homepagePageheader = (hasImg: boolean) => {
  return (
    <header className={`pageheader cf ${hasImg ? 'with' : 'no'}-image`}>
      <div className="pageheader__inner">
        <div className="pageheader__content container container--m">
          <div className="pageheader__header">
            <h1 className="pageheader__title">
              Lorem ipsum dolor sit amet.
            </h1>
            <p className="pageheader__intro">
              Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum.
              Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris.
              Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat
              pretium libero.
            </p>
          </div>
          <div className="pageheader__clickables">
            <div className="pageheader__clickable">
              <ExternalLink type="link" className="button button--primary" to="#">
                View our products
              </ExternalLink>
            </div>
          </div>
        </div>
        <div className="pageheader__visual fit-object">
          <img src="https://via.placeholder.com/2880x1620" alt="" className="pageheader__image" />
        </div>
      </div>
    </header>
  )
}

export const pageheader = (hasImg: boolean, landingpage?: boolean, vacancy?: boolean, isHome?: boolean, isApplication?: boolean) => {
  return (
    <header className={`pageheader ${hasImg ? 'with' : 'no'}-image pageheader--${isHome ? 'home' : 'page'}${landingpage ? ' pageheader--xl' : ''}${vacancy ? ' pageheader--vacancy' : ''}`}>
      <div className="pageheader__inner">
        <div className="pageheader__content container container--m">
          <div className="pageheader__header">
            <h1 className="pageheader__title">Lorem ipsum dolor sit amet.</h1>
            {(landingpage || vacancy) && (
              <p className="pageheader__intro">
                Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum.
                Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris.
                Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat
                pretium libero.
              </p>
            )}
          </div>
        </div>
        <div className={`pageheader__visual ${hasImg ? 'fit-object' : 'no-image'}`}>
          {hasImg && (
            <img
              src={StyleguideImgPlaceholder({
                shape: { width: 2880, height: 1620, radius: '0', bgColor: '#EE7401' },
                text: { color: '#FFF', font: 'Open Sans, sans-serif' }
              })}
              width="2880px"
              height="1620px"
              alt="placeholder image"
              className={`pageheader__image`}
            />
          )}
        </div>
      </div>
      {(landingpage || vacancy) && (
        <div className="pageheader__banner container container--m grid--gutter">
          <div className="pageheader__banner-inner grid--gutter">
            {landingpage &&
              <form className="pageheader__form">
                <div className="pageheader__form-inner">
                  <div className="pageheader__group">
                    <label className="pageheader__form-label text--l" htmlFor="id_select">
                      I would like to work in
                    </label>
                    <select id="id_select" className="pageheader__dropdown text--l" placeholder="accounting">
                      <option value="1"> Option1 </option>
                      <option value="2"> Option2 </option>
                    </select>
                  </div>
                  <div className="pageheader__group">
                    <label className="pageheader__form-label text--l" htmlFor="id_select-2">
                      in
                    </label>
                    <select id="id_select-2" className="pageheader__dropdown text--l" placeholder="United Kingdom">
                      <option value="1"> Option1 </option>
                      <option value="2"> Option2 </option>
                    </select>
                  </div>
                </div>
                <button className="pageheader__button button button--primary" type="submit" disabled>
                  Find vacansies
                </button>
              </form>
            }
            {vacancy && (<div className="pageheader__cta">
              <div className="pageheader__info">
                <h2 className="pageheader__text text--s">About this role:</h2>
                <ul className="pageheader__list">
                  {infoItem('Bridgwater UK', 'pin', 24, 16)}
                  {infoItem('Fulltime', 'clock', 24, 22)}
                  {infoItem('Supply chain', 'department', 22, 22)}
                </ul>
              </div>
              <div className="pageheader__action">
                <button className="button button--primary" type="submit">
                  Apply now
                </button>
              </div>
              </div>)
            }
          </div>
        </div>
      )}
      {(!landingpage && !vacancy && !isApplication) && breadcrumbs()}
    </header>
  )
}

export const infoItem = (title: string, icon: string, height: number, width: number) => {
  return (
    <li className="pageheader__item">
      <span>{title}</span>
      <svg className="pageheader__icon" aria-hidden="true" height={height} width={width}>
        <use xlinkHref={`#icon--${icon}`} />
      </svg>
    </li>
  )
}

